import { useEffect, useState } from "react";
import useFilter from "../tailwindUI/useFilter";

export function useFilters(filtersData) {
  const [filters, setFilters] = useState(filtersData);
  const [filterString, setFilterString] = useState("");

  const filterItem = useFilter();
  const [filtersApplied, setFiltersApplied] = useState(false);

  const handleApplyFilters = () => {
    setFilterString(filterItem(filters));
    setFiltersApplied(false);
  };

  const handleCleanFilters = () => {
    const newFilters = filters.map((filter) => {
      const newOptions = filter.options.map((option) => {
        return {
          ...option,
          applied: false,
          checked: false,
        };
      });
      return {
        ...filter,
        options: newOptions,
      };
    });
    setFilters(newFilters);
    setFiltersApplied(false);
    setFilterString("");
  };

  useEffect(() => {
    filtersApplied && handleApplyFilters();
  }, [filtersApplied]);

  return {
    filters,
    setFilters,
    filtersApplied,
    setFiltersApplied,
    filterString,
    handleApplyFilters,
    handleCleanFilters,
  };
}
